/**
 * 解析所有模块下Api接口装配到主Api配置文件中
 * @type {Null}
 */
const context = require.context('@src/modules', true, /\/api\/.*\.js$/);
let modulesApi = {};
context.keys().forEach(key => {
  modulesApi = { ...modulesApi, ...context(key).default }
});
export default modulesApi